export default __webpack_public_path__ + "static/media/carousel4.f009496e.png";